import * as React from 'react';

interface EmbeddedVideoProps {
    src: string;
    className?: string;
}

function EmbeddedVideo(props: EmbeddedVideoProps): JSX.Element {
    const {src, className} = props;

    return (
        <iframe
            data-testid="embedded-video"
            title="video player"
            width="100%"
            height="100%"
            className={className}
            src={src}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
        />
    );
}

export default EmbeddedVideo;
